export const DialogueTexts = {
    DELETE_SECTION: {
      TITLE: 'Confirm Delete',
      MESSAGE:
        'Are you sure you want to delete this report section? All related sub-sections will also be permanently deleted.',
      CONFIRM: 'Delete',
    },
    REWORK_SECTION: {
      TITLE: 'Send For ReWork',
      MESSAGE:
        'Please select the sections for rework. If none are selected, all sections will be submitted for rework.',
      CONFIRM: 'Send',
    },
  
    REPORT_STATUS: {
      TITLE: 'Report Status',
      MESSAGE: 'Report generation is in progress. You will be notified via email once the report generation is completed.',
      MESSAGE_V2: 'Report generation is in progress. Please check after some time.',
      CONFIRM: 'Recheck Status',
      CLOSE: 'Go Back',
      REGENERATE:'Regenerate Report',
      REGENERATE_MESSAGE:"Report generation failed. Please regenerate the report."
    },

    DELETE_COMMENT:{
        TITLE: 'Confirm Delete',
        MESSAGE: 'Are you sure you want to delete this comment?',
        CONFIRM: 'Delete Comment'
    },

    DELETE_REPORT: {
        TITLE: 'Confirm Delete',
        MESSAGE: 'Are you sure you want to delete this report?',
        CONFIRM: 'Delete Report'
      },
      FILTER_ERRORS:{
        TITLE: 'Error',
        CONFIRM: 'Close'
      }
      ,
      REPORT_MONTH:{
        CLOSE :'Close',
        CONFIRM:'OK'
      }
  };
  